import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import { STATUS_CODES_TO_IGNORE } from '../constants/StatusCodes';
let _cachedBannerGet;
export const resetTrialBannerCache = () => {
  _cachedBannerGet = null;
};
let _cachedAllBannersGet;
export const resetAllTrialBannersCache = () => {
  _cachedAllBannersGet = null;
};
/**
 *
 * @description Fetches the currently active trial banner being used by the given portal.
 * @link [ApiCatalog Link](https://tools.hubteam.com/api-catalog/services/GrowthModalsService/v1/spec/internal#operations-Banner-get-%2Fgrowth-modals%2Fv1%2Fbanner)
 */
export const fetchTrialBannerStatus = () => {
  if (_cachedBannerGet) {
    return _cachedBannerGet;
  }
  _cachedBannerGet = http.get(`${getFullUrl('app-api')}/growth-modals/v1/banner`).catch(error => {
    resetTrialBannerCache();
    if (!('status' in error) || !!error.status && !STATUS_CODES_TO_IGNORE.includes(error.status)) {
      Raven.captureException(new Error('Error fetching trial banner status'), {
        extra: {
          error
        }
      });
      return null;
    }
    return {};
  });
  return _cachedBannerGet;
};

/**
 *
 * @description Fetches all possible trial banners for the given portal.
 * @link [ApiCatalog Link](https://tools.hubteam.com/api-catalog/services/GrowthModalsService/v1/spec/internal#operations-Banner-get-%2Fgrowth-modals%2Fv1%2Fbanner%2Fall)
 */
export const fetchAllTrialBanners = () => {
  if (_cachedAllBannersGet && !window.jasmine) {
    return _cachedAllBannersGet;
  }
  _cachedAllBannersGet = http.get(`${getFullUrl('app-api')}/growth-modals/v1/banner/all`).catch(error => {
    resetAllTrialBannersCache();
    Raven.captureException(new Error('Failed fetching all trial banners'), {
      extra: {
        error
      }
    });
    throw error;
  });
  return _cachedAllBannersGet;
};